<div [class.small]="size === 'small'" [class.normal]="size === 'normal'" class="avatar">
  <img *ngIf="user.image else placeholder" class="profile-thumb" src="{{ user.image }}" />
  <ng-template #placeholder>
    <img class="profile-thumb" src="../../assets/img/profile_placeholder.jpg" />
  </ng-template>
</div>
<div [class.normal]="size === 'normal'" class="username">
  <span class="at">@</span>{{ user.username }}
</div>
